module.exports = __webpack_public_path__ + "media/images/img_placeholder-3087fc711059a3a2d7f2b8d031259abb.png";